<template>
  <div :class="[getClass, getRadius]" class="main-banner">
    <div class="main-banner__wrapper">
      <div class="main-banner__info">
        <h3 class="main-banner__header">
          <TextHeading color="base" variant="lg" semi>{{header}}</TextHeading>
        </h3>
        <BaseButton :variant="getButtonStyle">Read More</BaseButton>
      </div>
      <div class="main-banner__img">
        <img :src="getImage" alt="Alt description for the image">
      </div>
    </div>
  </div>
</template>

<script>
import BaseButton from '../elements/BaseButton.vue'
import TextHeading from '../elements/TextHeading.vue'
export default {
  name: 'MainBanner',
  components: { TextHeading, BaseButton },
  props: {
    image: {
      type: String,
      default: 'banner-plastic.png'
    },
    header: {
      type: String,
      default:
        'Introducing our 20p paper bags, sourced from forests that are managed responsibly.'
    },
    gradient: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      altText: 'Corporate Responsibility',
      aria: 'Read more about Reducing unnecessary packaging.'
    }
  },
  computed: {
    getButtonStyle() {
      return this.gradient ? 'secondary' : 'primary'
    },
    getImage() {
      return require('@/assets/images/' + this.image)
    },
    getClass() {
      return `${(this.gradient && 'main-banner--gradient') || ''}`
    },
    getRadius() {
      return `${(this.rounded && 'main-banner--rounded') || ''}`
    }
  }
}
</script>

<style lang="postcss">
.main-banner {
  @apply bg-primary-lightest mb-6;
}
.main-banner--gradient {
  @apply text-white bg-gradient-tl-primary;
}
.main-banner--rounded {
  @apply rounded-lg;
}
.main-banner__wrapper {
  @apply flex items-center;
}
.main-banner__info {
  @apply m-8 flex-1;
}
.main-banner__header {
  @apply mb-6;
}
.main-banner__img {
  @apply ml-8 relative hidden;
}
@screen md {
  .main-banner {
    @apply mb-20;
  }
  .main-banner__info {
    @apply ml-8 mr-8;
  }
  .main-banner__img {
    @apply block;
    width: 230px;
    height: 230px;
  }
  .main-banner__img img {
    @apply inset-0 absolute w-auto h-full;
    transform: scale(1.6) translateX(-16%);
  }
}
@screen lg {
  .main-banner__info {
    @apply ml-16 mr-20;
  }
  .main-banner__img {
    width: 280px;
    height: 280px;
  }
}
</style>
